const badges = [
  { icon: 'ri-time-line', label: '약 2분 소요' },
  { icon: 'ri-smartphone-line', label: '앱 설치 불필요' },
  { icon: 'ri-shield-check-line', label: '개인정보 안전' },
];

export default function TrustBadges() {
  return (
    <div
      className="flex items-center justify-center gap-3"
      style={{ animationDelay: '300ms' }}
    >
      {badges.map((b) => (
        <div
          key={b.label}
          className="flex items-center gap-1.5 rounded-full bg-white/80 px-3 py-1.5"
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className={`${b.icon} text-[#C6503C] text-sm`} />
          </span>
          <span className="text-xs text-[#55575D] whitespace-nowrap">{b.label}</span>
        </div>
      ))}
    </div>
  );
}